export default "__VITE_ASSET__e5998cc4__"